export const getIsQuantityErrorNeeded = (lineItemQuantityAvailable: number, quantity: number) => {
  return lineItemQuantityAvailable !== 0 && quantity > getMaxItemQuantity(lineItemQuantityAvailable);
};

export const getIsOutOfStock = (lineItemQuantityAvailable: number) => {
  return lineItemQuantityAvailable === 0;
};

export const getMaxItemQuantity = (lineItemQuantityAvailable: number) => {
  return lineItemQuantityAvailable || 99_999;
};
